/**
 * Call window.onerror when an error is caught (e.g. in a try...catch).
 */
export default function catchError(error) {
	const options = error.options || {};
	console.error(error); // Log the error in the console.
	if (error.response && error.response.headers) { // If the error occured while fetching data.
		options.headers = {};
		const iterator = error.response.headers.entries();
		let headers = iterator.next();
		while (!headers.done) {
			const header = headers.value;
			options.headers[header[0]] = header[1];
			headers = iterator.next();
		}
	}
	error.stackAddition = `
Options:
${JSON.stringify(options, null, '\t')}
`;
	window.onerror(error.message, error.filename, error.lineno, error.colno, error, error.stack);
}
